module.exports = __webpack_public_path__ + "static/media/turtly_head.849c9573.png";